'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Placeholder = require('./components/Placeholder.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Placeholder).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-table/lib/components/placeholder/index.js
// module id = 1348
// module chunks = 1